import { createFileRoute } from '@tanstack/react-router';
import { CarteiraPage, lerBuscaCarteira, mesAtual } from '@/components/plano';

export const Route = createFileRoute('/_app/plano/carteira')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaCarteira(bruto),
  component: CarteiraRota,
});

function CarteiraRota() {
  const busca = Route.useSearch();
  return <CarteiraPage mes={busca.mes ?? mesAtual()} aba={busca.aba ?? 'pedidos'} />;
}
